"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {findIn, on, toggleClass, closest, hasClass} from "@elements/dom-utils";
import {createAffix} from "@elements/affix";

export function init () {
    onFind('.js-show-all', function (baseElement) {
        let contentElement = findIn('.js-show-all__content', baseElement);
        let btn = findIn('.js-show-all__btn', baseElement);

        changeElementMaxHeight(contentElement);

        on('click', () => {
            toggleClass('show', btn);

            changeElementMaxHeight(contentElement);
        }, btn);
    });
}

function changeElementMaxHeight(element) {
    let maxHeight = parseInt(element.getAttribute('data-show-all-max-height'), 10);

    if (matchMedia('(max-width: 991px)').matches) {
        maxHeight = parseInt(element.getAttribute('data-show-all-max-height-mobile'), 10);
    }

    if (element.offsetHeight === maxHeight) {
        element.style.maxHeight = 'none';
    } else {
        element.style.maxHeight = maxHeight + 'px';
    }

    const affixElement = closest('.js-affix', element)
    if (affixElement) {
        if (element.offsetHeight > window.innerHeight && hasClass('is-affix', affixElement)) {
            affixElement.style = 'none';
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
        createAffix(affixElement, {mediaQuery: '(min-width: 992px)'});
    }
}